export enum SearchSort {
    Default = "",
    PriceDescending = "-price",
    PriceAscending = "price"
}

export enum IndexUrlParamPrefix {
    Product = "p",
    Content = "c"
}

export enum StorageKeys {
    CartsMerged = "carts_merged",
    DeliveryType = "delivery_type",
    CustomerEmail = "customer_email",
    GuestEmail = "guest_email",
    CustomerFirstName = "customer_firstName",
    CustomerLastName = "customer_lastName",
    ShouldCall = "should_call_",
    PreferredStore = "preferred-store",
    PreferredStoreDriveIn = "preferred-store-drive-in",
    BonusCardRequested = "bonuscard_requested",
    ProductComparisonSkuList = "product_comparison_sku_list",
    RecentlyViewedProducts = "recentlyViewed",
    PreviousCartData = "previousCartData",
    PreferredStoreLocalStorageKey = "preferredStoreId",
    PreferredDriveInStoreLocalStorageKey = "preferredDriveInStoreId",
    LocalWishlist = "localWishlist",
    CartStoreLocalStorageKey = "cachedCartStoreId",
    AlgoliaSearchQueryTracking = "algolia_query_tracking",
    AlgoliaUserToken = "algolia_user_token",
    AlgoliaAuthenticatedUserToken = "algolia_authenticated_user_token",
    AlgoliaDynamicFacetNamesAmount = "algolia_dynamicFacetNames_amount",
    AlgoliaDynamicFacetNamesCutoff = "algolia_dynamicFacetNames_cutoff",
    SearchParameters = "search_parameters",
    ScrollPosition = "scroll_position",
    MockDate = "mock_date",
    NeverbounceValidatedEmails = "neverbounce_validated_emails"
}

export enum BonusCardStatus {
    NoCard = "NO_CARD",
    Requested = "REQUESTED",
    CardOnRoute = "CARD_ON_ROUTE",
    HasCard = "HAS_CARD"
}

export enum CheckoutSteps {
    login = "login",
    account = "account",
    payment = "payment",
    confirmation = "confirmation"
}

export enum CounterDirections {
    DOWN = "down",
    UP = "up"
}

export enum CounterTheme {
    DARK = "dark",
    LIGHT = "light"
}

export enum CustomerOrderStatus {
    Created = "CREATED",
    PartiallyAvailable = "PARTIALLY_AVAILABLE",
    Available = "AVAILABLE",
    PartiallyCollected = "PARTIALLY_COLLECTED",
    Collected = "COLLECTED",
    Cancelled = "CANCELLED",
    CancelPending = "CANCEL_PENDING",
    TrackTrace = "TRACK_TRACE",
    MultipleTrackTrace = "MULTIPLE_TRACK_TRACE"
}

export enum PlaceOrderResultCode {
    SUCCESS = "SUCCESS",
    IDENTIFY = "IDENTIFY",
    CHALLENGE = "CHALLENGE",
    REDIRECT = "REDIRECT",
    PRESENT_QR = "PRESENT_SHOPPER",
    PRESENT_PAYCONIQ = "PRESENT_PAYCONIQ",
    PENDING = "PENDING"
}

export enum GiftCardStatus {
    Valid = "VALID",
    Expired = "EXPIRED",
    Locked = "LOCKED",
    Blocked = "BLOCKED",
    NoBalance = "NO_BALANCE",
    NotFound = "NOT_FOUND"
}

export enum GiftCardType {
    Gift = "CADEAU",
    HappyHolidays = "PRETTIGE_FEESTEN",
    Congratulations = "GEFELICITEERD",
    Digital = "DIGITALE_CADEAUKAART"
}

export enum PaymentTypes {
    QrCode = "qrCode"
}

export enum ApiMessage {
    CTAPresent = "CTA_PRESENT"
}

export enum ScrollOffsets {
    DEFAULT = 66
}

export enum PaymentModes {
    MasterCard = "MASTERCARD",
    Visa = "VISA",
    Bancontact = "BANCONTACT",
    BancontactMobileQr = "BANCONTACT_QR",
    BancontactMobileApp = "BANCONTACT_MOBILE",
    GiftCard = "GIFTCARD",
    Coupon = "COUPON",
    Scheme = "SCHEME",
    Terminal = "TERMINAL"
}

export enum CallToActionTypes {
    CHANGE_TO_HOME_DELIVERY = "CHANGE_TO_HOME_DELIVERY",
    CHANGE_STORE = "CHANGE_STORE",
    CHANGE_QUANTITIES = "CHANGE_QUANTITIES",
    ACCEPT_NEGATIVE_DELIVERY_PROMISE = "ACCEPT_NEGATIVE_DELIVERY_PROMISE",
    ACCEPT_POSITIVE_DELIVERY_PROMISE = "ACCEPT_POSITIVE_DELIVERY_PROMISE",
    REMOVE_ARTICLE = "REMOVE_ARTICLE",
    CHANGE_STORE_AND_CNC = "CHANGE_STORE_AND_CNC",
    CHANGE_TO_CNC = "CHANGE_TO_CNC",
    CHOOSE_STORE = "CHOOSE_STORE",
    CHANGE_STORE_TO_ECORNER = "CHANGE_STORE_TO_ECORNER",
    REMOVE_ACCESSORY_ARTICLE = "REMOVE_ACCESSORY_ARTICLE"
}

export enum PromotionTypes {
    PROMOTION = "PROMOTION",
    COUPON = "COUPON"
}

export enum HeaderKeys {
    orderIdPublic = "ORDER-ID-PUBLIC"
}

export enum Keys {
    BACKSPACE = 8,
    TAB = 9,
    ENTER = 13,
    SHIFT = 16,
    CTRL = 17,
    ALT = 18,
    ARROW_UP = 38,
    ARROW_DOWN = 40,
    META = 91,
    ESCAPE = 27,
    SPACE = 32,
    HOME = 36,
    END = 35,
    N = 78,
    P = 80
}

export enum KeyNames {
    ARROW_UP = "ArrowUp",
    ARROW_DOWN = "ArrowDown",
    ARROW_LEFT = "ArrowLeft",
    ARROW_RIGHT = "ArrowRight",
    ENTER = "Enter",
    ESCAPE = "Escape",
    TAB = "Tab",
    SPACE = " ",
    SHIFT = "Shift",
    CTRL = "Control",
    ALT = "Alt",
    BACKSPACE = "Backspace",
    DELETE = "Delete",
    HOME = "Home",
    END = "End",
    META = "Meta",
    K = "k"
}

export enum SafetyDocumentCategory {
    SDS = "SDS",
    DOP = "DOP"
}

export enum ProductListSources {
    algolia = "algolia",
    handPicked = "handpicked"
}

export enum Countries {
    BE = "BE",
    FR = "FR"
}

export enum BPOSTErrorSeverity {
    Warning = "warning",
    Error = "error"
}

// Size_width_height
export enum EmptyImages {
    Size_1_1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    Size_146_109 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNDYgMTA5Ij4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eTowIiAvPgo8L3N2Zz4=",
    Size_120_90 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0NjYgMjcwIj4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eTowIiAvPgo8L3N2Zz4="
}

export enum CookieList {
    ECORDER_ID = "ECORNER_ID",
    ECORNER_STORE_ID = "ECORNER_STORE_ID",
    ECORNER_TERMINAL_ID = "ECORNER_TERMINAL_ID",
    LANGUAGE = "HB_LANGUAGE",
    REVIEWS_FEEDBACK = "HB_REVIEWS_FEEDBACK"
}

export enum WeekDays {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY"
}

export enum PaymentStatus {
    PAID = "PAID",
    NOT_PAID = "NOT_PAID",
    PARTIALLY_PAYED = "PARTIALLY_PAID"
}

export enum StorePickerModalStates {
    AddToCart = "ADD_TO_CART",
    Closed = "CLOSED",
    Open = "OPEN"
}
